import { Component, Input, Output, EventEmitter } from "@angular/core";

/*##################################################################################*
 * COMPOSANT SPRO : spro-msg
 *
 * DESCRIPTION : Composant permettant l'affichage de message
 *
 * Il suffit de passer f_msg à true pour déclencher l'affichage
 ##################################################################################*/

@Component({
  selector: "spro-msg",
  template: `
    <kendo-dialog
      *ngIf="f_msg"
      [title]="'Messages.titre_information' | translate"
      (close)="proc_onClose()"
    >
      <p style="margin: 30px; text-align: center;">{{ w_msg | translate }}</p>

      <kendo-dialog-actions>
        <button class="k-button" (click)="proc_onClose()">
          {{ "Boutons.ok" | translate }}
        </button>
      </kendo-dialog-actions>
    </kendo-dialog>
  `
})
export class spro_cls_msg {
  /** Message de la fenêtre de dialogue */
  @Input() w_msg: string;
  /** Affichage oui/non de la fenêtre de dialogue */
  @Input() f_msg: boolean;

  /** Sortie de la fenêtre de dialogue */
  @Output() e_close: EventEmitter<any> = new EventEmitter();

  /**
   * Fermeture de la fenêtre de dialogue
   */
  public proc_onClose() {
    this.f_msg = false;
    this.e_close.emit();
  }
}



// WEBPACK FOOTER //
// C:/spro/Workspaces/VisualCode/Ecoltex2/src/app/sproLib/spro/utils/spro-msg/spro-msg.component.ts